import React, { useState } from "react";
import VehicleIaaIAndCopart from "../VehicleIaaIAndCopart";
import { useGetCarsQuery } from "../../redux/createApi";
import { Alert, Spinner } from "react-bootstrap";

// const SidebarFilters = () => {
//   const [accordions, setAccordions] = useState([
//     { id: 1, title: "Odometer", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 2, title: "Vehicle Title Type", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 3, title: "Year", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 4, title: "Vehicle Condition Type", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },

//     { id: 5, title: "Vehicle Title Type", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },

//     { id: 6, title: "Search Near ZIP Code", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 7, title: "Vehicle Type", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 8, title: "Make", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 9, title: "Model", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 10, title: "Engine Type", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 11, title: "Transmission", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 12, title: "Fuel Type", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     { id: 12, title: "Drive Train ", filters: ["Odometer", "Year", "Vehicle Condition Type", "Search Near ZIP Code", "Vehicle Type", "Make", "Model", "Engine Type", "Transmission", "Fuel Type", "Drive Train"], isOpen: false },
//     // Add more accordion items here if needed
//   ]);

//   const toggleAccordion = (id) => {
//     setAccordions((prev) =>
//       prev.map((accordion) =>
//         accordion.id === id ? { ...accordion, isOpen: !accordion.isOpen } : accordion
//       )
//     );
//   };
//   return (
//     <div
//       style={{
//         width: "300px",
//         borderRight: "1px solid #ddd",
//         padding: "15px",
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h5 style={{ fontWeight: "bold", color: "#0A92E2" }}>Search Filters</h5>
//         <button className="btn btn-link p-0">Reset All</button>
//         <i class="fa-solid fa-filter"></i>
//       </div>

//       <div>
//         <div className="mb-3">
//           <div className="form-check">
//             <input type="checkbox" className="form-check-input" id="vehiclesOnly" />
//             <label className="form-check-label" htmlFor="vehiclesOnly">
//               Select Vehicles Only
//             </label>
//           </div>
//           <div className="form-check form-switch">
//             <input type="checkbox" className="form-check-input" id="newlyAdded" />
//             <label className="form-check-label" htmlFor="newlyAdded">
//               Newly Added Vehicles, Last 24 Hours
//             </label>
//           </div>
//           <div className="form-check form-switch">
//             <input type="checkbox" className="form-check-input" id="excludeAuction" />
//             <label className="form-check-label" htmlFor="excludeAuction">
//               Exclude Upcoming Auction Vehicles
//             </label>
//           </div>
//         </div>

//         <div className="mb-3">
//           <input type="text" className="form-control" placeholder="Search..." style={{ marginBottom: "10px" }} />
//           <div className="form-check">
//             <input type="checkbox" className="form-check-input" id="cleanTitle" />
//             <label className="form-check-label" htmlFor="cleanTitle">
//               Clean Title (1,000)
//             </label>
//           </div>
//           <div className="form-check">
//             <input type="checkbox" className="form-check-input" id="nonRepairable" />
//             <label className="form-check-label" htmlFor="nonRepairable">
//               Non-Repairable (1,000)
//             </label>
//           </div>
//           <div className="form-check">
//             <input type="checkbox" className="form-check-input" id="salvageTitle" />
//             <label className="form-check-label" htmlFor="salvageTitle">
//               Salvage Title (10,000)
//             </label>
//           </div>
//         </div>


//         <div>
//           {accordions?.map(({ id, title, filters, isOpen }) => (
//             <div id={`accordionFlushExample${id}`} key={id}>
//               <div className="accordion-item">
//                 <h6 className="accordion-header" id={`flush-heading${id}`}>
//                   <button
//                     style={{
//                       fontSize: "15px",
//                       margin: "0px 0px",
//                       color: "blue",
//                       fontWeight: "300",
//                     }}
//                     className="ps-0 accordion-button"
//                     type="button"
//                     onClick={() => toggleAccordion(id)}
//                   >
//                     <h6 style={{ fontWeight: "bold", paddingTop: "15px" }}>
//                       {title} <button className="btn btn-link p-0">Reset</button>
//                     </h6>
//                     <span style={{ fontSize: "18px", marginLeft: "15px", paddingTop: "10px" }}>
//                       {isOpen ? "−" : "+"} {/* Conditional rendering of `+` or `−` */}
//                     </span>
//                   </button>
//                 </h6>
//                 <div
//                   id={`flush-collapse${id}`}
//                   className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
//                   aria-labelledby={`flush-heading${id}`}
//                   data-bs-parent={`#accordionFlushExample${id}`}
//                 >
//                   <div className="accordion-body">
//                     <div style={{ height: "160px", overflowY: "scroll" }}>
//                       {filters.map((filter, index) => (
//                         <div className="d-flex align-items-center" key={index}>
//                           <input type="checkbox" id={`filter-${id}-${index}`} />
//                           <label htmlFor={`filter-${id}-${index}`} className="mt-2 ms-2">
//                             {filter}
//                           </label>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };


const VehicleFinder = () => {
  const [page, setPage] = useState(1);
  const size = 12;
  const { data, isLoading, error } = useGetCarsQuery({ page, size, site: 2 });
  if (isLoading) {
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading cars...</p>
      </div>
    )
  }

  if (error) {
    return (
      <Alert variant="danger" className="mt-4 text-center">
        <Alert.Heading>Oops! Something went wrong.</Alert.Heading>
        <p>We couldn't fetch the cars at the moment. Please try again later.</p>
        {error?.status && <hr />}
        <p className="mb-0"><strong>Error Code:</strong> {error?.status}</p>
      </Alert>
    )
  }

  return (

    <>
      {/* 22-04-2025 Before Code */}
      {/* <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-md-3">
          <SidebarFilters />
        </div>

        <div className="col-md-9">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 style={{ fontWeight: "bold", color: "#333" }}>
              10,000+ Pure Sale for Sale
            </h3>
            <div>
              <button className="btn btn-primary mx-1">Export</button>
              <button className="btn btn-secondary mx-1">Save Search</button>
              <button className="btn btn-light mx-1">Classic View</button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style={headerStyle}>Image</th>
                  <th style={headerStyle}>Lot Info</th>
                  <th style={headerStyle}>Vehicle Info</th>
                  <th style={headerStyle}>Condition</th>
                  <th style={headerStyle}>Sale Info</th>
                  <th style={headerStyle}>Bids</th>
                </tr>
              </thead>
              <tbody>
                {vehicles?.map((vehicle) => (
                  <tr key={vehicle?.id}>
                    <td>
                      <img
                        src={vehicle?.link_img_hd[0]}
                        alt={vehicle?.lotInfo}
                        className="img-fluid"
                        style={{ width: "150px", borderRadius: "4px" }}
                      />
                    </td>
                    <td>
                      <div>
                        <strong>{vehicle?.lotInfo}</strong>
                      </div>
                      <div>Lot #: {vehicle?.lot_id}</div>
                      <button
                        className="btn btn-link text-primary"
                        onClick={() => toggleFavorite(vehicle?.id)}
                      >
                        <i
                          className={`fa-solid fa-heart fa-2xl ${favoriteVehicles.includes(vehicle?.id) ? "text-danger" : ""}`}
                          style={{ color: favoriteVehicles.includes(vehicle?.id) ? "#e40707" : "black" }}
                        ></i>
                      </button>
                    </td>
                    <td>
                      <div>Odometer: {vehicle?.odometer}</div>
                      <div>Estimated Value: {vehicle?.estimatedValue || "N/N"}</div>
                    </td>
                    <td>
                      <div>{vehicle?.title}</div>
                      <div>{vehicle?.damage_pr}</div>
                      <div>{vehicle?.keys}</div>
                    </td>
                    <td>
                      <div>{vehicle?.location}</div>
                      <div>{vehicle?.auction_type}</div>
                    </td>
                    <td>
                      <div>Current Bid: {vehicle?.current_bid}</div>
                      <button
                        className="btn btn-sm mx-1 marginTop-4px"
                        style={buttonBlue}
                      >
                        Bid Now
                      </button>
                      <button
                        className="btn btn-sm mx-1"
                        style={buttonYellow}
                        onClick={() => handleDetailsClick(vehicle)}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Vehicle Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedVehicle && (
            <div>
              {selectedVehicle?.link_img_hd?.length > 0 && (
                <Carousel
                  interval={null}
                  nextIcon={<FaChevronRight color="#000" size={24} />}
                  prevIcon={<FaChevronLeft color="#000" size={24} />}
                >
                  {selectedVehicle?.link_img_hd?.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        src={img}
                        alt={`Slide ${idx}`}
                        className="d-block mx-auto"
                        style={{ maxHeight: '300px', borderRadius: '8px' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              )}

              <Card className="mt-4 shadow-sm border-0">
                <Card.Body>
                  <Row>
                    <Col md={6} className="text-start">
                      <p className="text-start"><strong>Lot Number:</strong> {selectedVehicle?.lot_id}</p>
                      <p className="text-start"><strong>Odometer:</strong> {selectedVehicle?.odometer}</p>
                      <p className="text-start"><strong>Estimated Value:</strong> {selectedVehicle?.estimatedValue || "N/N"}</p>
                      <p className="text-start"><strong>Keys:</strong> {selectedVehicle?.keys}</p>
                    </Col>
                    <Col md={6}>
                      <p className="text-start"><strong>Condition:</strong> {selectedVehicle?.title} - {selectedVehicle?.damage_pr}</p>
                      <p className="text-start"><strong>Sale Location:</strong> {selectedVehicle?.location}</p>
                      <p className="text-start"><strong>Auction:</strong> {selectedVehicle?.auction_type}</p>
                      <p className="text-start"><strong>Current Bid:</strong> {selectedVehicle?.current_bid}</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      </div> */}

      {/* 22-04-2025 After Code */}
      <VehicleIaaIAndCopart
        vehicles={data?.data}
        totalItems={data?.count}
        page={page}
        setPage={setPage}
        size={size}
      />
    </>


  );
};

export default VehicleFinder;
